import type { Countries } from '@ps/web-shared-components';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { getCountry } from '@swf/core/utils/phoneVerification';
import states from '@swf/generated/states.json';

import {
  TXTCLI_Address,
  TXTCLI_City,
  TXTCLI_Country,
  TXTCLI_Name_person,
  TXTCLI_Phone_Number,
  TXTCLI_Zip_Post_Code,
  TXTWCL_According_to_Ontario_regulatio_ELL_1,
  TXTWCL_State___Province
} from './AccountDetailsSummary.messages.json';
import styles from './AccountDetailsSummary.scss';

const accountDetailFeilds = [
  { fieldName: 'name', tag: TXTCLI_Name_person },
  { fieldName: 'address', tag: TXTCLI_Address },
  { fieldName: 'city', tag: TXTCLI_City },
  { fieldName: 'state', tag: TXTWCL_State___Province },
  { fieldName: 'country', tag: TXTCLI_Country },
  { fieldName: 'zipCode', tag: TXTCLI_Zip_Post_Code },
  { fieldName: 'phone', tag: TXTCLI_Phone_Number }
];

const AccountDetailsSummary: React.FC = () => {
  const country = useSelector(select.account.getCountry);
  const state = useSelector(select.account.getAddressState);
  const initialCountry = country && getCountry(country)?.text;

  const countryStates = country && states[country];
  const initialState = (countryStates as Countries)?.find(({ value }) => value === state)?.text;

  const accountDetails = {
    name: useSelector(select.account.getFullName),
    address: useSelector(select.account.getAddress),
    city: useSelector(select.account.getCity),
    country: initialCountry,
    zipCode: useSelector(select.account.getZipCode),
    phone: useSelector(select.account.getPhone),
    state: initialState
  };

  return (
    <>
      <Translation tagName="p" {...TXTWCL_According_to_Ontario_regulatio_ELL_1} />
      {accountDetailFeilds.map(
        (field, index) =>
          accountDetails &&
          accountDetails[field.fieldName] && (
            <div className={styles.container} key={index}>
              <b className={styles.info}>
                <Translation {...field.tag} />
              </b>
              <span>{accountDetails[field.fieldName]}</span>
            </div>
          )
      )}
    </>
  );
};

export default AccountDetailsSummary;
